/* Avada Joy - account menu behaviour. Delegated, so one listener covers the
   header, the menu drawer and the mobile dock even though the snippet renders
   the markup more than once per page. */
(function () {
  if (window.__avadaAccountMenu) return;
  window.__avadaAccountMenu = true;

  var OPEN_CLASS = 'is-open';

  function setOpen(root, open) {
    if (!root) return;
    root.classList.toggle(OPEN_CLASS, open);
    var trigger = root.querySelector('.joy-account__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    var open = document.querySelectorAll('.joy-account.' + OPEN_CLASS);
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) setOpen(open[i], false);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('.joy-account__trigger');
    if (trigger && trigger.tagName === 'BUTTON') {
      var root = trigger.closest('.joy-account');
      var willOpen = !root.classList.contains(OPEN_CLASS);
      event.preventDefault();
      closeAll(root);
      setOpen(root, willOpen);
      if (willOpen) {
        var first = root.querySelector('.joy-account__link');
        if (first) first.focus({preventScroll: true});
      }
      return;
    }

    var closeButton = target.closest('.joy-account__close');
    if (closeButton) {
      var closing = closeButton.closest('.joy-account');
      setOpen(closing, false);
      var back = closing.querySelector('.joy-account__trigger');
      if (back) back.focus({preventScroll: true});
      return;
    }

    // Crown Club keeps its default click so the #crownclub shim in
    // 'avada-custom-header' can open the Joy widget; we only close the panel.
    var link = target.closest('.joy-account__link');
    if (link) {
      setOpen(link.closest('.joy-account'), false);
      return;
    }

    if (!target.closest('.joy-account')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var open = document.querySelector('.joy-account.' + OPEN_CLASS);
    if (!open) return;
    setOpen(open, false);
    var trigger = open.querySelector('.joy-account__trigger');
    if (trigger) trigger.focus({preventScroll: true});
  });
})();
